const lightMode = {
  base: "#FFFFFF",
  secondary: "#DEDEDE",
  title: "#676f99",
  text: "#333",
  shadow: "#AAA",
  lightShadow: "#888",
  nav: "#FFFFFF",
  lightText: "#444",
  success: "#2e7d32",
  danger: "#d32f2f",
  navBottom: "#EEE",
};

const darkMode = {
  nav: "#2E2E2E",
  base: "#2E2E2E",
  secondary: "#3E3E3E",
  title: "#272F5A",
  text: "white",
  shadow: "#222",
  lightShadow: "grey",
  lightText: "#F0F0F0",
  success: "#4caf50",
  danger: "#ef5350",
  navBottom: "#292929",
};

module.exports = {
  STYLISH_DARK: "#2E2E2E",
  HEADING_FONT: '"Inter", "Roboto", "Helvetica", sans-serif',
  getColorWithMode: (isDarkMode, key) => {
    return isDarkMode ? darkMode[key] : lightMode[key];
  },
  getAccent: (isDarkMode) => (isDarkMode ? "#90caf9" : "#1976d2"),
  getBorder: (isDarkMode) =>
    isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)",
  getMutedText: (isDarkMode) =>
    isDarkMode ? "rgba(255,255,255,0.68)" : "rgba(0,0,0,0.6)",
  // Shared modern DataGrid styling: rounded card, token borders, uppercase
  // Inter headers, subtle blue row hover.
  getDataGridSx: (isDarkMode) => {
    const border = isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)";
    return {
      borderRadius: "12px",
      borderColor: border,
      "& .MuiDataGrid-columnHeaderTitle": {
        fontFamily: '"Inter", "Roboto", "Helvetica", sans-serif',
        fontWeight: 600,
        fontSize: "11px",
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        color: isDarkMode ? "rgba(255,255,255,0.68)" : "rgba(0,0,0,0.6)",
      },
      "& .MuiDataGrid-columnHeaders": {
        borderColor: border,
      },
      "& .MuiDataGrid-cell": {
        borderColor: border,
      },
      "& .MuiDataGrid-row:hover": {
        backgroundColor: isDarkMode
          ? "rgba(144,202,249,0.06)"
          : "rgba(25,118,210,0.04)",
      },
      "& .MuiDataGrid-pinnedRows": {
        boxShadow: "none",
      },
    };
  },
};
